import {
  ADD_SHIFT,
  ADD_SHIFT_FAIL,
  ADD_SHIFT_SUCCESS,
  GET_SHIFTS,
  GET_SHIFTS_FAIL,
  GET_SHIFTS_SUCCESS,
  UPDATE_SHIFT,
  UPDATE_SHIFT_SUCCESS,
  UPDATE_SHIFT_FAIL,
  DELETE_SHIFT,
  DELETE_SHIFT_SUCCESS,
  DELETE_SHIFT_FAIL,
  SHIFT_LOGS,
  SHIFT_LOGS_SUCCESS,
  SHIFT_LOGS_FAIL,
  SHIFT_REPORT_SUCCESS,
  SHIFT_REPORT_FAIL,
  SHIFT_REPORT,
  CANCEL_SHIFT_ADMIN,
  CANCEL_SHIFT_ADMIN_SUCCESS,
  CANCEL_SHIFT_ADMIN_FAIL,
} from "./actionTypes";

export const cancelShift = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: CANCEL_SHIFT_ADMIN,
  payload: { data, onSuccess, onError },
});

export const cancelShiftSuccess = data => ({
  type: CANCEL_SHIFT_ADMIN_SUCCESS,
  payload: data,
});

export const cancelShiftFail = data => ({
  type: CANCEL_SHIFT_ADMIN_FAIL,
  payload: data,
});

export const deleteShift = data => ({
  type: DELETE_SHIFT,
  payload: data,
});

export const deleteShiftSuccess = data => ({
  type: DELETE_SHIFT_SUCCESS,
  payload: data,
});

export const deleteShiftFail = data => ({
  type: DELETE_SHIFT_FAIL,
  payload: data,
});

export const shiftReport = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SHIFT_REPORT,
  payload: { data, onSuccess, onError },
});

export const shiftReportSuccess = data => ({
  type: SHIFT_REPORT_SUCCESS,
  payload: data,
});

export const shiftReportFail = data => ({
  type: SHIFT_REPORT_FAIL,
  payload: data,
});

export const shiftLogs = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SHIFT_LOGS,
  payload: { data, onSuccess, onError },
});

export const shiftLogsSuccess = data => ({
  type: SHIFT_LOGS_SUCCESS,
  payload: data,
});

export const shiftLogsFail = data => ({
  type: SHIFT_LOGS_FAIL,
  payload: data,
});

export const updateShift = data => ({
  type: UPDATE_SHIFT,
  payload: data,
});

export const updateShiftSuccess = data => ({
  type: UPDATE_SHIFT_SUCCESS,
  payload: data,
});

export const updateShiftFail = data => ({
  type: UPDATE_SHIFT_FAIL,
  payload: data,
});

export const getShifts = data => ({
  type: GET_SHIFTS,
  payload: data,
});
export const getShiftsSuccess = data => ({
  type: GET_SHIFTS_SUCCESS,
  payload: data,
});
export const getShiftsFail = error => ({
  type: GET_SHIFTS_FAIL,
  payload: error,
});

export const addShift = data => ({
  type: ADD_SHIFT,
  payload: data,
});
export const addShiftSuccess = data => ({
  type: ADD_SHIFT_SUCCESS,
  payload: data,
});
export const addShiftFail = error => ({
  type: ADD_SHIFT_FAIL,
  payload: error,
});
